import React from 'react';
import { HeaderBar } from './components/HeaderBar';
import { HeroSection } from './components/HeroSection';
import { ProblemSection } from './components/ProblemSection';
import { EbookContents } from './components/EbookContents';
import { Testimonials } from './components/Testimonials';
import { CouplesTestimonials } from './components/CouplesTestimonials';
import { AboutPaula } from './components/AboutPaula';
import { OfferBonuses } from './components/OfferBonuses';
import { Guarantee } from './components/Guarantee';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { FloatingCTA } from './components/FloatingCTA';
import { SalesNotification } from './components/SalesNotification';
import { MetaPixel } from './components/MetaPixel';
import { ThankYouPage } from './pages/ThankYouPage';
function isThankYouPage() {
  if (typeof window === 'undefined') return false;
  const params = new URLSearchParams(window.location.search);
  return params.get('page') === 'gracias';
}
export function App() {
  if (isThankYouPage()) {
    return <>
        <MetaPixel data-id="element-0" />
        <ThankYouPage data-id="element-1" />
      </>;
  }
  return <div className="min-h-screen flex flex-col selection:bg-gold-main/30 selection:text-brown-dark" data-id="element-2">
      <MetaPixel data-id="element-3" />
      <HeaderBar data-id="element-4" />
      <main className="flex-grow" data-id="element-5">
        <HeroSection data-id="element-6" />
        <ProblemSection data-id="element-7" />
        <EbookContents data-id="element-8" />
        <Testimonials data-id="element-9" />
        <CouplesTestimonials data-id="element-10" />
        <AboutPaula data-id="element-11" />
        <OfferBonuses data-id="element-12" />
        <Guarantee data-id="element-13" />
        <FAQ data-id="element-14" />
        <FinalCTA data-id="element-15" />
      </main>
      <Footer data-id="element-16" />
      <FloatingCTA data-id="element-17" />
      <SalesNotification data-id="element-18" />
    </div>;
}